const Client_Data = [
  {
    client: "Rajiv Punia",
    img: require("../assets/images/client-3.jpg"),
    star: "4.5",
    description: "seamless user experiences.",
  },
  {
    client: "Mahesh Chandra",
    img: require("../assets/images/client-2.webp"),
    star: "4",
    description: "responsive designs and excellent user interactions.",
  },
  {
    client: "Samanta Kashyap",
    img: require("../assets/images/client-1.jpg"),
    star: "4",
    description: "Custom features and responsive layouts",
  },
  {
    client: 'Virat Gupta',
    img: require('../assets/images/client-5.jpg'),
    star: '5',
    description: 'responsive design were well-executed.'
  },
  {
    client: 'Brittany Kaufman',
    img: require('../assets/images/client-4.jpg'),
    star: '3',
    description: 'Have to More Speed and Efficency'
  },
  {
    client: 'Courtney Sniadecki',
    img: require('../assets/images/client-6.jpg'),
    star: '3.5',
    description: 'Reliable Framework',
  },
  {
    client: 'Tyler Sanslow',
    img: require('../assets/images/client-7.jpg'),
    star: '5',
    description: 'Efficient React development',
  },
  {
    client: 'Justing Sires',
    img: require('../assets/images/client-8.jpg'),
    star: '4',
    description: 'Responsive layouts'
  }
];
export default Client_Data;
